// @flow

import type {Language, EventRule, EventRuleChange} from '@/types'

import React from 'react'
import {connect} from 'react-redux'
import {toggleActive} from '@/rules-helper'
import {appSelectors} from '@/store'
import InfoAlert from '@/elements/info-alert'

type Props = {
  l: Language,
  raiseChange: (EventRuleChange) => void,
  rule: EventRule,
  tooltip?: Array<string>,
  alert?: string,
}

export const RawBool = (props: Props) =>
  <div className="checkbox">
    <label>
      <input
        type="checkbox"
        onChange={() => props.raiseChange({
          ruleCode: props.rule.ruleCode,
          prop: 'isActive',
          val: toggleActive(props.rule),
          check: false,
        })}
        checked={props.rule.isActive}
        title={props.tooltip && props.tooltip[0]}
      />
      {props.l(props.rule.name.trim())}
    </label>
    {props.alert ? <InfoAlert alertText={props.alert} l={props.l} /> : null}
  </div>

const mapStateToProps = (state) => ({
  l: appSelectors.getL(state),
})

export default connect(
  mapStateToProps,
)(RawBool)



// WEBPACK FOOTER //
// ./src/views/settings-page/rules/bool.js